module.exports = __webpack_public_path__ + "img/sort-alpha-up-alt.78c71dd4.svg";